// Digest: 4f28a8e70bbcaa40c7ebbbac8bb1257ffd9b1ecd
/* eslint-disable */
/// <reference types="vite/client.d.ts" />/* eslint-disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export type ContainerSizeSubBlockOrNull = null | ContainerSizeSubBlock;
export type AlignedRichTextSubBlockOrNull = null | AlignedRichTextSubBlock;
export type RichTextBlockOrNull = null | RichTextBlock;
export type RichTextBlock = string;
export type _SlideListOrNull = null | _SlideList;
export type ImageChooserBlockOrNull = null | ImageChooserBlock;
export type _SlideList = _Slide[];
export type CharBlockOrNull = null | CharBlock;
export type CharBlock = string;
export type EmbedBlockOrNull = null | EmbedBlock;
export type EmbedBlock = string;
export type MediaChooserBlock = (
  | {
      type: "image";
      value: ImageChooserBlock;
      id: string;
    }
  | {
      type: "video";
      value: VideoChooserBlock;
      id: string;
    }
  | {
      type: "embed";
      value: MediaEmbedBlock;
      id: string;
    }
)[];
export type URLBlockOrNull = null | URLBlock;
export type URLBlock = string;
export type TableBlockOrNull = null | TableBlock;
export type TableBlock = string;
export type LabUIToolbox = (
  | {
      type: "alignedrichtextblock";
      value: AlignedRichTextBlock;
      id: string;
    }
  | {
      type: "gallerysubblock";
      value: GallerySubBlock;
      id: string;
    }
  | {
      type: "linksubblock";
      value: LinkSubBlock;
      id: string;
    }
  | {
      type: "mediachooserblock";
      value: MediaChooserBlock;
      id: string;
    }
  | {
      type: "scrollnavmenublock";
      value: ScrollNavMenuBlock;
      id: string;
    }
  | {
      type: "scrollnavmenuitemblock";
      value: ScrollNavMenuItemBlock;
      id: string;
    }
  | {
      type: "socialmediaicon";
      value: SocialMediaIcon;
      id: string;
    }
  | {
      type: "spacerblock";
      value: SpacerBlock;
      id: string;
    }
  | {
      type: "tableincontainerblock";
      value: TableInContainerBlock;
      id: string;
    }
  | {
      type: "onetrustprivacynoticeblock";
      value: OneTrustPrivacyNoticeBlock;
      id: string;
    }
  | {
      type: "videochooserblock";
      value: VideoChooserBlock;
      id: string;
    }
)[];
export type AnchorBlock = string;
export type ResponsiveVisibilitySubBlockOrNull = null | ResponsiveVisibilitySubBlock;
export type MediaChooserBlockOrNull = null | MediaChooserBlock;
export type _ValueProp = (
  | {
      type: "icon";
      value: ImageChooserBlock;
      id: string;
    }
  | {
      type: "content";
      value: RichTextBlock;
      id: string;
    }
)[];
export type RawHTMLBlock = string;
export type _Column = (
  | {
      type: "image";
      value: ImageChooserBlock;
      id: string;
    }
  | {
      type: "aligned_rich_text_block";
      value: AlignedRichTextSubBlock;
      id: string;
    }
  | {
      type: "value_props";
      value: {
        type: "value_prop";
        value: _ValueProp;
        id: string;
      }[];
      id: string;
    }
  | {
      type: "raw_HTML";
      value: RawHTMLBlock;
      id: string;
    }
)[];
export type SpacingSubBlockOrNull = null | SpacingSubBlock;
export type SimpleLinkBlockOrNull = null | SimpleLinkBlock;
export type Toolbox = (
  | {
      type: "anchor";
      value: AnchorBlock;
      id: string;
    }
  | {
      type: "artf";
      value: AlignedRichTextSubBlock;
      id: string;
    }
  | {
      type: "columns_carousel";
      value: ColumnsCarouselBlock;
      id: string;
    }
  | {
      type: "gallery_carousel";
      value: GalleryCarouselBlock;
      id: string;
    }
  | {
      type: "hardcoded";
      value: HardcodedBlock;
      id: string;
    }
  | {
      type: "info_list";
      value: InfoListBlock;
      id: string;
    }
  | {
      type: "promotion";
      value: PromotionBlock;
      id: string;
    }
  | {
      type: "html_ad_bar";
      value: HTMLAdBarBlock;
      id: string;
    }
  | {
      type: "onetrustprivacynoticeblock";
      value: OneTrustPrivacyNoticeBlock;
      id: string;
    }
)[];
export type MetaTagsBlock = (
  | {
      type: "domain_verification";
      value: DomainVerificationBlock;
      id: string;
    }
  | {
      type: "gtm";
      value: GoogleTagManagerBlock;
      id: string;
    }
  | {
      type: "onetrust_cookie_settings";
      value: OneTrustCookieSettingsBlock;
      id: string;
    }
)[];
export type HeaderNavigationBodyBlock = {
  type: "menu_item";
  value: _MenuItem;
  id: string;
}[];
export type FooterContentBlock = {
  type: "footer_content";
  value: FooterContent;
  id: string;
}[];

export interface _Types {
  BasePageTemplateProps: ThelabuiModelsPagesBasePageBasePageTemplate;
  BaseFormPageTemplateProps: ThelabuiModelsPagesBaseFormPageBaseFormPageTemplate;
  BaseFormPageLandingPageTemplateProps: ThelabuiModelsPagesBaseFormPageBaseFormPageLandingPageTemplate;
  ExamplePageTemplateProps: ThelabuiModelsPagesExamplePageExamplePageTemplate;
  LabUIToolboxSnippetPreviewProps: ThelabuiModelsSnippetsToolboxSnippetLabUIToolboxSnippetPreview;
  UtilityPageTemplateProps: ServerCmsModelsPagesUtilityPageUtilityPageTemplate;
  StockQuoteProps: ServerCmsModelsStocksStockQuote;
  globals: {
    Widget: generated.Types["Widget"];
    models: {};
  };
  Context: ReactivatedSerializationContextProcessorsBaseContext &
    ReactivatedSerializationContextProcessorsMessagesProcessor &
    ReactivatedSerializationContextProcessorsCSRFProcessor &
    ReactivatedSerializationContextProcessorsRequestProcessor &
    ReactivatedSerializationContextProcessorsStaticProcessor &
    ThelabuiContextProcessorsTranslationProcessor &
    ThelabuiContextProcessorsMetaTagsProcessor &
    ServerCmsContextProcessorsCoreAssetProcessor &
    ServerCmsContextProcessorsSettingsProcessor &
    ServerCmsContextProcessorsNavigationProcessor &
    ServerCmsContextProcessorsFooterProcessor &
    ServerCmsContextProcessorsStockQuoteProcessor;
  RPCPermission: null;
}
export interface ThelabuiModelsPagesBasePageBasePageTemplate {
  is_preview: boolean;
  page: BasePageEb66F00405;
}
export interface BasePageEb66F00405 {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  language: ThelabuiTypesLanguage | null;
  alternate_pages: ThelabuiTypesAlternatePage[];
}
export interface ThelabuiTypesLanguage {
  code: string;
  vernacular_name: string;
  translated_name: string;
  dir: "ltr" | "rtl" | "auto";
}
export interface ThelabuiTypesAlternatePage {
  title: string;
  url: string;
  language: ThelabuiTypesLanguage;
}
export interface ThelabuiModelsPagesBaseFormPageBaseFormPageTemplate {
  is_preview: boolean;
  page: BaseFormPageFe4F84D43A;
  form: DjangoFormsForms;
}
export interface BaseFormPageFe4F84D43A {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  language: ThelabuiTypesLanguage | null;
  alternate_pages: ThelabuiTypesAlternatePage[];
}
export interface DjangoFormsForms {
  name: "django.forms.forms.Form";
  errors: {} | null;
  fields: {};
  prefix: string;
  iterator: [];
  hidden_fields?: [];
}
export interface ThelabuiModelsPagesBaseFormPageBaseFormPageLandingPageTemplate {
  is_preview: boolean;
  page: BaseFormPageFe4F84D43A;
}
export interface ThelabuiModelsPagesExamplePageExamplePageTemplate {
  is_preview: boolean;
  page: ExamplePage_8C9639Cb8F;
}
export interface ExamplePage_8C9639Cb8F {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  language: ThelabuiTypesLanguage | null;
  alternate_pages: ThelabuiTypesAlternatePage[];
  image: {
    block: ThelabuiSerializationImagesImageBlockValue;
  } | null;
  image_tile: {
    renditions_webp: WagtailImageRendition[];
  } | null;
  richtext: RichTextField;
  body: ThelabuiExamplePage;
  snippets: {
    body: ThelabuiLabUIToolboxSnippet;
  }[];
  attachment: {
    title: string;
    created_at: string;
    file_size: number | null;
    file_hash: string;
    filename: string;
    file_extension: string;
    url: string;
    content_type: string;
    content_disposition: string;
    file: FileField;
    tags: {
      name: string;
    }[];
  } | null;
}
export interface ThelabuiSerializationImagesImageBlockValue {
  title: string;
  width: number;
  height: number;
  brightness: number;
  url: string;
  renditions: {
    [k: string]: ThelabuiSerializationImagesImageRenditionBlockValue;
  };
}
export interface ThelabuiSerializationImagesImageRenditionBlockValue {
  spec: string;
  width: number;
  height: number;
  url: string;
  size: number;
  mimetype: string;
}
export interface WagtailImageRendition {
  spec: string;
  width: number;
  height: number;
  url: string;
  size: number;
  mimetype: string;
}
export interface RichTextField {
  _type: "RichTextField";
  html: string;
}
export interface ThelabuiExamplePage {
  _type: "StreamField";
  _variant: "thelabui.ExamplePage.body";
  value: LabUIToolbox;
  [k: string]: unknown;
}
export interface AlignedRichTextBlock {
  container?: ContainerSizeSubBlockOrNull;
  content?: AlignedRichTextSubBlockOrNull;
}
export interface ContainerSizeSubBlock {
  width?: null | ("" | "full" | "twoThirds" | "half");
}
export interface AlignedRichTextSubBlock {
  content?: RichTextBlockOrNull;
  alignment?: null | ("" | "textAlignCenter" | "textAlignRight");
}
export interface GallerySubBlock {
  slides?: _SlideListOrNull;
}
export interface _Slide {
  image: ImageChooserBlockOrNull;
  caption?: AlignedRichTextSubBlockOrNull;
}
export interface ImageChooserBlock {
  title: string;
  width: number;
  height: number;
  brightness: number;
  url: string;
  renditions: {
    /**
     * This interface was referenced by `undefined`'s JSON-Schema definition
     * via the `patternProperty` "^.*$".
     */
    [k: string]: {
      spec: string;
      width: number;
      height: number;
      url: string;
      size: number;
      mimetype: string;
    };
  };
}
export interface LinkSubBlock {
  display_name?: CharBlockOrNull;
  link_type?: null | ("page" | "external" | "email" | "document");
  anchor?: CharBlockOrNull;
  link_style?: null | ("" | "secondary" | "text-link");
  url: null | string;
}
export interface VideoChooserBlock {
  poster: null | string;
  sources: {
    url: string;
    mimetype: string;
  }[];
  title: string;
  tracks: {
    kind: string;
    kind_name: string;
    src: string;
    label: string;
    srclang: string;
    srclang_name: null | string;
    sort_order: number;
  }[];
  width: null | number;
  height: null | number;
  aspectRatio: null | number;
}
export interface MediaEmbedBlock {
  title: CharBlockOrNull;
  thumbnail: ImageChooserBlockOrNull;
  embed: EmbedBlockOrNull;
}
export interface ScrollNavMenuBlock {}
export interface ScrollNavMenuItemBlock {
  name: CharBlockOrNull;
}
export interface SocialMediaIcon {
  icon: null | ("facebook" | "instagram" | "linkedin" | "pinterest" | "tiktok" | "twitter" | "youtube");
  link: URLBlockOrNull;
}
export interface SpacerBlock {
  anchor?: CharBlockOrNull;
  height: null | ("no-height" | "small" | "medium" | "large" | "xlarge" | "xxlarge");
}
export interface TableInContainerBlock {
  container?: ContainerSizeSubBlockOrNull;
  table: TableBlockOrNull;
}
export interface OneTrustPrivacyNoticeBlock {
  script_url: URLBlockOrNull;
  callback_url: URLBlockOrNull;
  notice_url: URLBlockOrNull;
}
export interface ThelabuiLabUIToolboxSnippet {
  _type: "StreamField";
  _variant: "thelabui.LabUIToolboxSnippet.body";
  value: LabUIToolbox;
  [k: string]: unknown;
}
export interface FileField {
  url: string;
}
export interface ThelabuiModelsSnippetsToolboxSnippetLabUIToolboxSnippetPreview {
  object: LabUIToolboxSnippetFdc2906E1B;
}
export interface LabUIToolboxSnippetFdc2906E1B {
  id: number;
  name: string;
  body: ThelabuiLabUIToolboxSnippet;
}
export interface ServerCmsModelsPagesUtilityPageUtilityPageTemplate {
  is_preview: boolean;
  page: UtilityPage_50D2Cb36C2;
}
export interface UtilityPage_50D2Cb36C2 {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  body: CmsUtilityPage;
}
export interface CmsUtilityPage {
  _type: "StreamField";
  _variant: "cms.UtilityPage.body";
  value: Toolbox;
  [k: string]: unknown;
}
export interface ColumnsCarouselBlock {
  responsive_visibility?: ResponsiveVisibilitySubBlockOrNull;
  header_content?: AlignedRichTextSubBlockOrNull;
  columns:
    | null
    | {
        type: "column";
        value: _CarouselColumn;
        id: string;
      }[];
}
export interface ResponsiveVisibilitySubBlock {
  visibility?: null | ("" | "smallOnly" | "mediumOnly" | "mediumAndSmaller" | "mediumAndLarger" | "largeOnly");
}
export interface _CarouselColumn {
  content?: RichTextBlockOrNull;
  image?: ImageChooserBlockOrNull;
}
export interface GalleryCarouselBlock {
  responsive_visibility?: ResponsiveVisibilitySubBlockOrNull;
  header_content?: AlignedRichTextSubBlockOrNull;
  slides:
    | null
    | {
        type: "slide";
        value: _GallerySlide;
        id: string;
      }[];
}
export interface _GallerySlide {
  content?: RichTextBlockOrNull;
  image?: ImageChooserBlockOrNull;
}
export interface HardcodedBlock {
  responsive_visibility?: ResponsiveVisibilitySubBlockOrNull;
  version: null | ("social-banner" | "ceo-message" | "jd-power");
}
export interface InfoListBlock {
  title: CharBlockOrNull;
  items:
    | null
    | {
        type: "item";
        value: _Item;
        id: string;
      }[];
}
export interface _Item {
  image?: ImageChooserBlockOrNull;
  content: RichTextBlockOrNull;
}
export interface PromotionBlock {
  variant?: null | ("" | "soloBoxLeft" | "soloBoxRight" | "soloTextLeft" | "fixedIconSize");
  background_style?: null | ("" | "alabaster" | "blue" | "white");
  responsive_visibility?: ResponsiveVisibilitySubBlockOrNull;
  background_media?: MediaChooserBlockOrNull;
  header_content?: AlignedRichTextSubBlockOrNull;
  column_layout?: null | ("" | "firstColGrow" | "lastColGrow" | "twoColEven");
  columns:
    | null
    | {
        type: "column";
        value: _Column;
        id: string;
      }[];
  footer_content?: AlignedRichTextSubBlockOrNull;
}
export interface HTMLAdBarBlock {
  spacing?: SpacingSubBlockOrNull;
  content:
    | null
    | (
        | {
            type: "image_link";
            value: _LinkImage;
            id: string;
          }
        | {
            type: "raw_HTML";
            value: RawHTMLBlock;
            id: string;
          }
      )[];
}
export interface SpacingSubBlock {
  top_spacing?: null | ("" | "topXSmall" | "topSmall" | "topMedium" | "topLarge" | "topXLarge");
  top_inner_spacing?:
    | null
    | ("" | "topInnerXSmall" | "topInnerSmall" | "topInnerMedium" | "topInnerLarge" | "topInnerXLarge");
  bottom_spacing?: null | ("" | "bottomXSmall" | "bottomSmall" | "bottomMedium" | "bottomLarge" | "bottomXLarge");
  bottom_inner_spacing?:
    | null
    | ("" | "bottomInnerXSmall" | "bottomInnerSmall" | "bottomInnerMedium" | "bottomInnerLarge" | "bottomInnerXLarge");
}
export interface _LinkImage {
  image: ImageChooserBlockOrNull;
  link?: SimpleLinkBlockOrNull;
}
export interface SimpleLinkBlock {
  display_name?: CharBlockOrNull;
  link_type?: null | ("page" | "external" | "email" | "document");
  anchor?: CharBlockOrNull;
  url: null | string;
}
export interface ServerCmsModelsStocksStockQuote {
  askSize: number | null;
  bid: number | null;
  bidSize: number | null;
  changeNumber: number;
  changePercent: number;
  date: string;
  dayHigh: number;
  dayLow: number;
  exchange: string | null;
  exchangeShortCode: string | null;
  firstTradeDate: string | null;
  isDefault: boolean;
  isIndex: boolean;
  lastTrade: number;
  marketCap: number | null;
  open: number;
  peRatio: number | null;
  previousClose: number;
  rollingEPS: number | null;
  securityId: number;
  sharesOutstanding: number | null;
  symbol: string;
  volume: number | null;
}
export interface ReactivatedSerializationContextProcessorsBaseContext {
  template_name: string;
}
export interface ReactivatedSerializationContextProcessorsMessagesProcessor {
  messages: ReactivatedSerializationContextProcessorsMessage[];
}
export interface ReactivatedSerializationContextProcessorsMessage {
  level_tag: "info" | "success" | "error" | "warning" | "debug";
  message: string;
  level: number;
  from_server: boolean;
}
export interface ReactivatedSerializationContextProcessorsCSRFProcessor {
  csrf_token: string;
}
export interface ReactivatedSerializationContextProcessorsRequestProcessor {
  request: ReactivatedSerializationContextProcessorsRequest;
}
export interface ReactivatedSerializationContextProcessorsRequest {
  path: string;
  url: string;
  csp_nonce: string | null;
}
export interface ReactivatedSerializationContextProcessorsStaticProcessor {
  STATIC_URL: string;
}
export interface ThelabuiContextProcessorsTranslationProcessor {
  i18n: ThelabuiContextProcessorsTranslationCatalog;
}
export interface ThelabuiContextProcessorsTranslationCatalog {
  language: ThelabuiTypesLanguage;
  catalog: ThelabuiContextProcessorsCatalogEntry[];
  formats: ThelabuiContextProcessorsFormatEntry[];
}
export interface ThelabuiContextProcessorsCatalogEntry {
  key: string;
  value: string;
}
export interface ThelabuiContextProcessorsFormatEntry {
  key: string;
  value: string | number | string[];
}
export interface ThelabuiContextProcessorsMetaTagsProcessor {
  meta_tags: MetaTagSettings_3D1Fcbef23;
}
export interface MetaTagSettings_3D1Fcbef23 {
  meta_tags: ThelabuiMetaTagSettings;
}
export interface ThelabuiMetaTagSettings {
  _type: "StreamField";
  _variant: "thelabui.MetaTagSettings.meta_tags";
  value: MetaTagsBlock;
  [k: string]: unknown;
}
export interface DomainVerificationBlock {
  type: null | ("" | "google-site-verification" | "p:domain_verify" | "facebook-domain-verification");
  value: CharBlockOrNull;
}
export interface GoogleTagManagerBlock {
  container_id: CharBlockOrNull;
}
export interface OneTrustCookieSettingsBlock {
  domain_script_uuid: CharBlockOrNull;
}
export interface ServerCmsContextProcessorsCoreAssetProcessor {
  core_assets: ServerCmsContextProcessorsCoreAssets;
}
export interface ServerCmsContextProcessorsCoreAssets {
  favicon: string;
  logo: string;
}
export interface ServerCmsContextProcessorsSettingsProcessor {
  CI_COMMIT_REF_SLUG: string;
  CI_COMMIT_SHA: string;
  SENTRY_DSN: string | null;
}
export interface ServerCmsContextProcessorsNavigationProcessor {
  header_nav: HeaderNavigationSettings_41Bc9Da531 | null;
}
export interface HeaderNavigationSettings_41Bc9Da531 {
  body: CmsHeaderNavigationSettings;
}
export interface CmsHeaderNavigationSettings {
  _type: "StreamField";
  _variant: "cms.HeaderNavigationSettings.body";
  value: HeaderNavigationBodyBlock;
  [k: string]: unknown;
}
export interface _MenuItem {
  menu_link?: SimpleLinkBlockOrNull;
  sub_menu_items?:
    | null
    | {
        type: "sub_menu_item";
        value: SimpleLinkBlock;
        id: string;
      }[];
}
export interface ServerCmsContextProcessorsFooterProcessor {
  footer_content: FooterContentSettings_8F21Aa9Df3 | null;
}
export interface FooterContentSettings_8F21Aa9Df3 {
  content: CmsFooterContentSettings;
}
export interface CmsFooterContentSettings {
  _type: "StreamField";
  _variant: "cms.FooterContentSettings.content";
  value: FooterContentBlock;
  [k: string]: unknown;
}
export interface FooterContent {
  copyright: CharBlockOrNull;
  privacy_policy: URLBlockOrNull;
  cali_privacy_policy: URLBlockOrNull;
  terms: URLBlockOrNull;
  disclaimer?: AlignedRichTextSubBlockOrNull;
}
export interface ServerCmsContextProcessorsStockQuoteProcessor {
  stock_quotes: ServerCmsModelsStocksStockQuote[];
}
export class RPC {
    constructor(public requester: rpcUtils.Requester) {
    }
}
export type UUID = `${string}-${string}-${string}-${string}-${string}`;

import type {Renderer as GenericRenderer} from "reactivated/dist/render.mjs";
export type Renderer = GenericRenderer<_Types["Context"]>;

export const rpc = new RPC(typeof window != "undefined" ? rpcUtils.defaultRequester : null as any);
import React from "react"
import * as generated from "reactivated/dist/generated";
import * as rpcUtils from "reactivated/dist/rpc";
import {constants} from "./constants";
export {constants};

export function classNames(...classes: (string | undefined | null | false)[]) {
    return classes.filter(Boolean).join(" ");
}

// Note: this needs strict function types to behave correctly with excess properties etc.
export type Checker<P, U extends (React.FunctionComponent<P> | React.ComponentClass<P>)> = {};

export type Result<TSuccess, TInvalid> = rpcUtils.Result<TSuccess, TInvalid, _Types["RPCPermission"]>;

export {Context} from "./context";
import {Context} from "./context";

import * as forms from "reactivated/dist/forms";
export type {FormHandler} from "reactivated/dist/forms";
export {reverse} from "./urls";

export const Provider = (props: {value: _Types["Context"]; children: React.ReactNode}) => {
    const [value, setValue] = React.useState(props.value);

    return (
        <Context.Provider value={{...value, setValue}}>
            {props.children}
        </Context.Provider>
    );
};

export const getServerData = () => {
    const props: Record<string, unknown> = (window as any).__PRELOADED_PROPS__;
    const context: _Types["Context"] = (window as any).__PRELOADED_CONTEXT__;

    return {props, context};
};

export type models = _Types["globals"]["models"];

export type {FieldHandler} from "./forms";
export {Form, FormSet, Widget, useForm, useFormSet, ManagementForm} from "reactivated/dist/forms";


import {Template as BasePageTemplateImplementation} from "@client/templates/BasePageTemplate"
export type BasePageTemplateCheck = Checker<_Types["BasePageTemplateProps"], typeof BasePageTemplateImplementation>;

export namespace templates {
    export type BasePageTemplate = _Types["BasePageTemplateProps"];
}


        



import {Template as BaseFormPageTemplateImplementation} from "@client/templates/BaseFormPageTemplate"
export type BaseFormPageTemplateCheck = Checker<_Types["BaseFormPageTemplateProps"], typeof BaseFormPageTemplateImplementation>;

export namespace templates {
    export type BaseFormPageTemplate = _Types["BaseFormPageTemplateProps"];
}


        



import {Template as BaseFormPageLandingPageTemplateImplementation} from "@client/templates/BaseFormPageLandingPageTemplate"
export type BaseFormPageLandingPageTemplateCheck = Checker<_Types["BaseFormPageLandingPageTemplateProps"], typeof BaseFormPageLandingPageTemplateImplementation>;

export namespace templates {
    export type BaseFormPageLandingPageTemplate = _Types["BaseFormPageLandingPageTemplateProps"];
}


        



import {Template as ExamplePageTemplateImplementation} from "@client/templates/ExamplePageTemplate"
export type ExamplePageTemplateCheck = Checker<_Types["ExamplePageTemplateProps"], typeof ExamplePageTemplateImplementation>;

export namespace templates {
    export type ExamplePageTemplate = _Types["ExamplePageTemplateProps"];
}


        



import {Template as LabUIToolboxSnippetPreviewImplementation} from "@client/templates/LabUIToolboxSnippetPreview"
export type LabUIToolboxSnippetPreviewCheck = Checker<_Types["LabUIToolboxSnippetPreviewProps"], typeof LabUIToolboxSnippetPreviewImplementation>;

export namespace templates {
    export type LabUIToolboxSnippetPreview = _Types["LabUIToolboxSnippetPreviewProps"];
}


        



import {Template as UtilityPageTemplateImplementation} from "@client/templates/UtilityPageTemplate"
export type UtilityPageTemplateCheck = Checker<_Types["UtilityPageTemplateProps"], typeof UtilityPageTemplateImplementation>;

export namespace templates {
    export type UtilityPageTemplate = _Types["UtilityPageTemplateProps"];
}


        



export namespace interfaces {
    export type StockQuote = _Types["StockQuoteProps"];
}


        
export {Iterator, CSRFToken, createRenderer} from "./forms";
export {getTemplate} from "./template";

